<template>
    <Dialog v-model:visible="show" modal header="Material Wizard" :style="{ width: '75rem' }" :closable="false">
        <template #header>
        </template>
        <div class="px-6 pt-2 mb-12">
            <div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4">
                    <div class="col">
                        <div class="mb-8">
                            <label for="materialTitle" class="block text-primary dark:text-surface-0 font-medium mb-2">Title</label>
                            <InputText id="materialTitle" type="text" size="large" class="w-full" v-model="materialTitle" :useGrouping="false" />
                        </div>
                        <div class="mb-8">
                            <label for="materialProductName" class="block text-primary dark:text-surface-0 font-medium mb-2">Product Name</label>
                            <InputText id="materialProductName" type="text" size="large" class="w-full" v-model="materialProductName" :useGrouping="false" />
                        </div>
                        <div>
                            <label for="materialProductPrice" class="block text-primary dark:text-surface-0 font-medium mb-2">Product Price</label>
                            <InputNumber id="materialProductPrice" class="w-full" inputId="currency-us" mode="currency" currency="USD" locale="en-US" v-model="materialProductPrice" :invalid="noThreshold" @input="thresholdCheck($event)" />
                            <Message icon=" pi pi-times-circle" severity="error" v-if="noThreshold" class="mt-4">Tier for the given value not found</Message>
                        </div>
                    </div>
                    <div class="col">
                        <label class="block text-primary dark:text-surface-0 font-medium mb-2">Product Image</label>
                        <div class="grid grid-cols-4 gap-4 h-80 overflow-y-auto" v-if="!uploadNew && !imageSelected">
                            <div v-for="(image, idx) in productImages" v-if="productImages" >
                                <img :src="image.path" class="h-32 w-32 shadow-lg cursor-pointer rounded-lg" @click="selectProductImage(idx)"/>
                            </div>
                        </div>
                        <div class="mt-8 text-center text-primary font-semibolds" v-if="!uploadNew && !imageSelected">
                            <a href="#" @click.prevent="uploadNew = true; ">upload new image</a>
                        </div>
                        <div class="flex justify-center rounded-lg border border-gray-900/25 h-72" v-if="uploadNew || imageSelected">
                            <div class="flex flex-col justify-center h-full">
                                <svg v-if="!imageSelected" class="mx-auto h-12 w-12 text-gray-300" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clip-rule="evenodd" />
                                </svg>
                                <div class="relative inline-block" v-if="imageSelected">
                                    <a class="absolute top-1/2 left-0 right-0 w-full h-12 flex items-center justify-center bg-black bg-opacity-50 text-white text-sm transition-opacity cursor-pointer" @click="materialProductImage = null;imagePreview = null;imageSelected = false; materialProductImageId = null; uploadNew = false">change image</a>
                                    <img :src="imagePreview" class="h-64 w-auto my-4"/>
                                </div>
                                <div class="flex text-sm leading-6 text-gray-600" v-if="!imageSelected && materialProductImage == null">
                                    <label for="image" class="relative cursor-pointer rounded-md bg-white font-semibold text-primary focus-within:outline-none focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 hover:text-primary">
                                        <span>click to select a file</span>
                                        <input id="image" name="image" type="file" class="sr-only" @change="loadImagePreview" accept=".jpg,.jpeg,.png">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button class="self-end" severity="secondary" @click="tiersWarning = false; imagePreview = null; uploadNew = false; imageSelected = false; $emit('close')" label="Cancel"/>
            <div class="flex gap-4 flex-col md:flex-row justify-end items-center grow">
                <Button @click.prevent="submitMaterial()">
                    <ProgressSpinner style="width: 20px; height: 20px; color: #fff" strokeWidth="6" fill="transparent" animationDuration=".5s" v-if="submitting" :pt:circle:class="'!stroke-white'" />
                    <span>Submit</span>
                </Button>
            </div>
        </template>
    </Dialog>
</template>

<style>
.p-inputnumber-input {
    padding-top: 0.73rem !important;
    padding-bottom: 0.73rem !important;
}
</style>

<script>
import axios from "axios";
import { debounce } from 'lodash-es';
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import { computed, defineComponent, ref, toRefs, watch, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
//import { useStore } from '../../stores/store';
import store from '../../stores/store';

export default defineComponent({
    name: 'MaterialWizard',
    title: 'Material Wizard',
    emits: ['close', 'refresh'],
    props: ['show'],
    components: {

    },
    setup(props, { emit }) {

        const instance = getCurrentInstance();
        try {
            const router = useRouter();
            const route = useRoute();
            //const store = useStore();
            const confirm = useConfirm();
            const toast = useToast();
            const { show } = toRefs(props);
            const app_web = import.meta.env.VITE_APP_WEB;
            const submitting = ref(false);
            const noThreshold = ref(false);
            const tiers = ref([]);
            const selectedTier = ref(null);
            const thresholds = ref([]);
            const terms = ref({});
            const sendConfirmation = ref(false);
            const sendTarget = ref('email');
            const tiersWarning = ref(false);
            const tiersPreventProgress = ref(false);
            const tiersWarningMessage = ref('');
            const menu = ref();
            const confirmation = ref(false);
            const confirmationMode = ref(null);
            const imageSelected = ref(false);
            const imagePreview = ref(null);
            const materialProductImage = ref(null);
            const materialProductImageId = ref(null);
            const productImages = ref([]);
            const uploadNew = ref(false);

            const toggle = (event) => {
                menu.value.toggle(event);
            };

            const materialTitle = computed({
                get() {
                    return store.materialWizard.material.title;
                },
                set(value) {
                    store.materialWizard.material.title = value;
                }
            });

            const materialProductName = computed({
                get() {
                    return store.materialWizard.material.product;
                },
                set(value) {
                    store.materialWizard.material.product = value;
                }
            });

            const materialProductPrice = computed({
                get() {
                    return store.materialWizard.material.cost;
                },
                set(value) {
                    store.materialWizard.material.cost = value;
                }
            });

            const thresholdCheck = debounce((event) => {
                let val = event.value;
                noThreshold.value = false;
                selectedTier.value = null;
                store.materialWizard.material.cost = val;
                for (const thr of thresholds.value) {
                    // now check
                    if (thr.TierThresholdStart == null && parseFloat(val) <= thr.TierThresholdEnd) {
                        selectedTier.value = thr.TierId;
                        break;
                    }
                    else if (parseFloat(val) >= thr.TierThresholdStart && parseFloat(val) <= thr.TierThresholdEnd) {
                        selectedTier.value = thr.TierId;
                        break;
                    }
                    else if (parseFloat(val) >= thr.TierThresholdStart && thr.TierThresholdEnd == null) {
                        selectedTier.value = thr.TierId;
                        break;
                    }
                };

                noThreshold.value = (selectedTier.value === null) ? true : false;
            }, 500);

            const fetchTiers = () => {
                //reset tiers
                if(store.materialWizard.material.seller_company_id == null) {
                    console.log('company not set');
                    return false;
                }
                noThreshold.value = false;
                tiers.value = [];
                selectedTier.value = null;
                thresholds.value = [];
                terms.value = {};
                axios({
                    method: "GET",
                    url: import.meta.env.VITE_APP_API + "/tiers/company/" + store.materialWizard.material.seller_company_id,
                    headers: { Authorization: 'Bearer ' + store.token },
                }).then((response) => {
                    if (response.data.length > 0) {
                        tiers.value = response.data;
                        // terms
                        response.data.forEach(function (item) {
                            terms.value[item.id] = item.terms;
                        });
                        // thresholds
                        response.data.forEach(function (item) {
                            if (item.thresholds !== null) {
                                thresholds.value.push(item.thresholds);
                            }
                        });
                        if (thresholds.value.length < tiers.value.length) {
                            tiersWarning.value = true;
                            tiersPreventProgress.value = false;
                            tiersWarningMessage.value = "It appears not every tier in the parent company has it's value thresholds set - this may have an adverse effect when creating quotes";
                        }
                    } else {
                        tiersWarning.value = true;
                        tiersPreventProgress.value = true;
                        tiersWarningMessage.value = 'Parent seller company does not have any financing tiers assigned. The system will not be able to create the quote';
                    }
                })
                    .catch(() => {
                        //fetching.value = false;
                    })
            }

            fetchTiers(); // assuming user company by default

            const loadImagePreview = (e) => {
                const file = e.target.files[0];
                imagePreview.value = URL.createObjectURL(file);
                imageSelected.value = true;
                materialProductImage.value = e.target.files[0];
            }

            const setImage = () => {
                const existingImage = productImages.value.find(
                    (img) => img.image_id === materialProductImageId.value
                );
                if (existingImage) {
                    imagePreview.value = existingImage.path;
                }
            }

            watch(() => show.value, (newValue, oldValue) => {
                // Trigger getQuotes() whenever the user changes
                if (newValue) {
                    if(store.user.company) {
                        fetchTiers(store.user.company.Id);
                    }

                }
            });

            //watch changes to product image on user store
            watch(() => store.materialWizard.editData, (newVal) => {
                if (store.materialWizard.mode === 'edit' && newVal?.ImageId) {
                    imagePreview.value = newVal.image?.path || null;
                    imageSelected.value = true;
                    materialProductImageId.value = newVal.ImageId;
                }
            },
            { immediate: true } // run immediately in case data is already present
            );


            const getMaterials = () => {
                let queryParams = '';
                // if user is being impersonated add the user id to the request query
                if (Object.keys(store.impersonator).length > 0) {
                    queryParams = '?impersonate=' + store.user.Id;
                }
                // or if we are at company page pass the company id directly
                if (store.activeSellerCompanyId !== null) {
                    queryParams = '?company_id=' + store.activeSellerCompanyId;
                }
                axios({
                    method: 'GET',
                    url: import.meta.env.VITE_APP_API + '/promotional-materials' + queryParams,
                    headers: { Authorization: 'Bearer ' + store.token }
                })
                    .then((response) => {
                        store.materials = response.data;
                    })
                    .catch(() => {
                    });
            };

            const getProductImages = () => {
                let queryParams = '';
                // or if we are at company page pass the company id directly
                if (store.activeSellerCompanyId !== null) {
                    queryParams = '?company_id=' + store.activeSellerCompanyId;
                }
                axios({
                    method: 'GET',
                    url: import.meta.env.VITE_APP_API + '/promotional-materials/images' + queryParams,
                    headers: { Authorization: 'Bearer ' + store.token }
                })
                    .then((response) => {
                        productImages.value = response.data;
                    })
                    .catch(() => {
                    });
            };

            getProductImages();

            const selectProductImage = (index) => {
                imageSelected.value = true;
                uploadNew.value = false;
                materialProductImageId.value = productImages.value[index].image_id;
                setImage();
            }

            return {
                app_web,
                confirmation,
                confirmationMode,
                imagePreview,
                imageSelected,
                loadImagePreview,
                materialProductImage,
                materialProductName,
                materialProductPrice,
                materialTitle,
                noThreshold,
                productImages,
                selectedTier,
                store,
                submitting,
                tiers,
                thresholds,
                terms,
                sendConfirmation,
                sendTarget,
                thresholdCheck,
                tiersWarningMessage,
                tiersWarning,
                tiersPreventProgress,
                toast,
                toggle,
                menu,
                getMaterials,
                uploadNew,
                selectProductImage,
                materialProductImageId,
                setImage,

                submitMaterial() {
                    submitting.value = true;
                    let queryParams = '';
                    // if user is being impersonated add the user id to the request query
                    if (Object.keys(store.impersonator).length > 0) {
                        queryParams = '?impersonate=' + store.user.Id;
                    }

                    let formData = new FormData();
                    let materialId = '';
                    if(store.materialWizard.mode == 'edit') {
                        formData.set("_method", 'PUT');
                        materialId = '/'+store.materialWizard.editData.Id;
                    }
                    formData.set("SellerCompanyId", store.materialWizard.material.seller_company_id);
                    formData.set("Title", store.materialWizard.material.title);
                    formData.set("Product", store.materialWizard.material.product);
                    formData.set("Price", store.materialWizard.material.cost);
                    formData.set("Terms", JSON.stringify(terms.value[selectedTier.value]));
                    formData.set("CreatedBy", store.user.ContactId);
                    if(materialProductImageId.value !== null) {
                        formData.set("ProductImageId", materialProductImageId.value);
                    } else {
                        formData.set("ProductImage", materialProductImage.value);
                    }

                    axios({
                        method: "POST",
                        url: import.meta.env.VITE_APP_API + '/promotional-materials/one-pager'+materialId,
                        data: formData,
                        headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer ' + store.token },
                    }).then(
                        response => {
                            submitting.value = false;
                            getMaterials();
                            store.materialWizard.material.show = false;
                            store.materialWizard.material.title = null;
                            store.materialWizard.material.product = null;
                            store.materialWizard.material.cost = 0;
                            imagePreview.value = null;
                            imageSelected.value = false;
                            uploadNew.value = false;
                            materialProductImage.value = null;
                            materialProductImageId.value = null;
                            let msg = store.materialWizard.mode == 'edit' ? 'Promotional material updated' : 'Promotional material created';
                            toast.add({ severity: 'success', summary: 'Success', detail: msg, life: 5000 });
                            emit('close');
                        },
                        error => {
                            let msg = store.materialWizard.mode == 'edit' ? 'Unable to update promotional material' : 'Unable to create new promotional material'
                            toast.add({ severity: 'error', summary: 'Error', detail: msg, life: 5000 });
                        }
                    );

                },

            }
        } catch (error) {
            instance.appContext.config.globalProperties.$logError(error.message, 'unknown', null, null, error);
        }
    }

});
</script>

<style scoped></style>